import { NgtUniversalModule } from "@ng-toolkit/universal";
import { CommonModule } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TransferHttpCacheModule } from "@nguniversal/common";
import { NgModule, LOCALE_ID } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NavBarComponent } from "./components/nav-bar/nav-bar.component";
import { FooterComponent } from "./components/footer/footer.component";
import { AlertModule } from "./views/alert/alert.module";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { AppAr, AppEn } from "../environments/translate";
import { JsonModuleLoaderService } from "./service/translate-loader/json-module-loader.service";
import { environment } from "../environments/environment";
import { TransferStateInterceptorService } from "./http-confing/interceptors/transfer-state/transfer-state-interceptor.service";

const TRANSLATIONS = {
  ar: AppAr,
  en: AppEn
};

export function createTranslateLoader() {
  return new JsonModuleLoaderService(TRANSLATIONS);
}

@NgModule({
  declarations: [AppComponent, NavBarComponent, FooterComponent],
  imports: [
    CommonModule,
    NgtUniversalModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TransferHttpCacheModule,
    AlertModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader
      }
    })
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: environment.locale
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TransferStateInterceptorService,
      multi: true
    }
  ]
})
export class AppModule {}
